import React from 'react';
import snakeToPascal from '../../tools';

import OutputFloatField from '../ModelDataFields/Output/Float';
import OutputGridField from '../ModelDataFields/Output/Grid';

const OutputFieldByType: Record<string, React.ComponentType<any>> = {
    'float': OutputFloatField,
    'grid': OutputGridField,
};

interface ParameterCardProps {
    item: any;
    fields: Array<[string, any]>;
    reloadState: () => void;
    currentState: any;
    userRights: any;
    scenarioId?: number | null;
    onNavigate?: (modelDataId: string) => void;
}

const noop = () => {};

export default function ParameterCard({
    item,
    fields,
    reloadState,
    currentState,
    userRights,
    scenarioId = null,
    onNavigate,
}: ParameterCardProps) {
    if (fields.length === 0) {
        return null;
    }

    return (
        <div className="mb-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {fields.map(([name, field]) => {
                    const FieldComponent = OutputFieldByType[field.type];
                    if (!FieldComponent) return null;

                    // Set model_data_id as ModelDataFieldDetailsPanel does
                    field.model_data_id = item.id;

                    return (
                        <div
                            key={name}
                            className=""
                        >
                            <div className="mb-2">
                                <span className="text-xs font-medium text-slate-500">
                                    {field.display_name || snakeToPascal(name)}
                                </span>
                            </div>
                            {field.compute_error && (
                                <div className="text-xs text-red-600 bg-red-50 px-2 py-1 rounded mb-2">
                                    {field.compute_error}
                                </div>
                            )}
                            <FieldComponent
                                name={snakeToPascal(name)}
                                field={field}
                                reloadState={reloadState}
                                currentState={currentState}
                                recreateExcelInput={noop}
                                userRights={userRights}
                                scenarioId={scenarioId}
                                onNavigate={onNavigate}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
